import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(TextField)(({ theme }) => ({
	'.MuiFilledInput-root': {
		position: 'relative',
		backgroundColor: `${theme.palette.neutral[0]} !important`,
		border: `1px solid ${theme.palette.neutral[60]}`,
		borderRadius: '8px',
		minHeight: '56px',
		paddingRight: 0,
		'.Mui-focused, :hover:not(.Mui-error):not(.Mui-disabled), :active:not(.Mui-error):not(.Mui-disabled)':
			{
				borderColor: theme.palette.primary.main,
			},

		'@media (hover: hover)': {
			'.MuiFilledInput-root: hover': {
				borderColor: theme.palette.primary.main,
			},
		},
	},

	'.MuiFilledInput-input': {
		...theme.typography.body1,
	},

	'.MuiInputLabel-shrink': {
		...theme.typography.caption,
		transform: 'translate(12px, 7px) scale(1)',
	},

	'.Mui-error': {
		color: theme.palette.error.main,
		borderColor: theme.palette.error.main,

		'.MuiFilledInput-input': {
			color: theme.palette.neutral[100],
		},
	},

	'.MuiFormHelperText-root': {
		width: `calc(100% - 16px)`,
		marginLeft: '16px',
		...theme.typography.caption,
		svg: {
			color: theme.palette.error.main,
			marginBottom: '-3px',
			marginRight: 8,
		},
		span: {
			color: theme.palette.neutral[100],
		},
	},

	'.MuiInputBase-input:-webkit-autofill': {
		borderTopLeftRadius: 'inherit',
		borderTopRightRadius: 'inherit',
		borderBottomLeftRadius: 'inherit',
		borderBottomRightRadius: 'inherit',
		height: '21px',
	},

	'.MuiInputAdornment-root': {
		position: 'absolute',
	},
}));
